import React from 'react';
import MonitoringPriorityBadge from 'components/atoms/monitoring_priority_badge';
import { MONITORING_PRIORITIES, MonitoringPriority } from 'services/monitoring_settings';
import { Container } from './styles';

interface MonitoringPrioritySelectProps {
  value: MonitoringPriority;
  label: string;
  disabled: boolean;
  onChange: (priority: MonitoringPriority) => void;
}

const MonitoringPrioritySelect = ({
  value,
  label,
  disabled,
  onChange,
}: MonitoringPrioritySelectProps) => (
  <Container className={disabled ? 'disabled' : ''}>
    <MonitoringPriorityBadge priority={value} />
    <i className="material-icons" aria-hidden="true">
      arrow_drop_down
    </i>
    <select
      aria-label={label}
      value={value}
      disabled={disabled}
      onChange={(event) => onChange(event.target.value as MonitoringPriority)}
    >
      {MONITORING_PRIORITIES.map((priority) => (
        <option key={priority.value} value={priority.value}>
          {priority.label}
        </option>
      ))}
    </select>
  </Container>
);

export default MonitoringPrioritySelect;
